import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import camelcaseKeys from 'camelcase-keys'
import SessionManager from '@src/lib/session_manager'
import UserClubSummary from '@src/data/user-club-summary'

export class UserClubSummaryService {

  apiClient: ApiClient = new ApiClient()

  get (): Promise<UserClubSummary> {
    return this.apiClient.get<any>(SessionManager.Instance.isManager() ? API.TRAINERS_API.MY_CLUB_SUMMARY : API.MEMBERS_API.MY_CLUB_SUMMARY)
      .then(response => {
        const processedResponse = {
          ...response,
          onlineStations: response!.online_stations ? response.online_stations.map(station => camelcaseKeys(station)) : []
        }
        const userClubSummary = new UserClubSummary(camelcaseKeys(processedResponse))
        return Promise.resolve(userClubSummary)
      })
      .catch(error => {
        console.error('failed to retrieve member club summary', error)
        return Promise.reject(error)
      })
  }

  getLeaderBoard (clubID, type): Promise<any> {
    const params: any = { type }
    if (clubID) {
      params.club_id = clubID
    }
    return this.apiClient.get<any>(SessionManager.Instance.isManager() ? API.TRAINERS_API.MY_CLUB_LEADERBOARD : API.MEMBERS_API.MY_CLUB_LEADERBOARD, params)
      .then(response => {
        return Promise.resolve(response.leaderboard)
      })
      .catch(error => {
        console.error('failed to retrieve member club leaderboard', error)
        return Promise.reject(error)
      })
  }
}
